import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '../Services/translation';
import { setReseller, setOrderRowsWithBahagInfo, activeSignInSection, getProductIdByEan, getProductStockByEan, createAndOrAddToCart, createAndAddToCart, updateCartEntry, updateCartDeliveryAddress, removeEntryFromCart, createOrder, cancelOrder, submitOrder, createCustomer, login, logout, forgotPassword, addAddress, getPaymentMode, getPaymentModeByCartId } from '../actions/Bahag.action';
import { load, receive } from "../actions/Cart.action";

//ToDo 
//Resellers are hardcoded we have just one reseller and no logic how they want to implement it. 
const mockData = [
    {
        id: "bahag",
        imageUrl: '/UI/images/bahaus.png',
        button: translate("checkout.bahag.reseller.choose"),
        name: "BAUHAUS"
    },
    //{
    //    id: "Jula",
    //    imageUrl: '/UI/images/bahag.png',
    //    button: translate("checkout.bahag.reseller.choose"),
    //    name: "Jula"
    //},
    //{
    //    id: "Item 3",
    //    imageUrl: '/UI/images/bahag.png',
    //    button: translate("checkout.bahag.reseller.choose"),
    //    name: "Item3"
    //},
    //{
    //    id: 'Item 4',
    //    imageUrl: '/UI/images/bahag.png',
    //    button: translate("checkout.bahag.reseller.choose"),
    //    name: "Item4"

    //},
    //{
    //    id: 'Item 5',
    //    imageUrl: '/UI/images/bahag.png',
    //    button: translate("checkout.bahag.reseller.choose"),
    //    name: "Item5"
    //},
];

//ToDo Change resellers when there s more than one
class GermanyChooseReseller extends Component {
    constructor(props) {
        super(props);

        this.state = {
            resellerAmount: 1,
            showResellerOptions: false,
            totalAvailableProducts: null,
            allProductsAvailable: true,
            isScrollButtonClicked: false,
            selectedReseller: null,
            selectedItemId: null,
            isMobileOrTablet: window.innerWidth <= 1024
        };
        this.goToSignSection = this.goToSignSection.bind(this);
        this.goToShoppingCart = this.goToShoppingCart.bind(this);
        this.scrollToNextSection = this.scrollToNextSection.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.productStockMap = new Map();
    }

    handleResize() {
        this.setState({ isMobile: window.innerWidth <= 1024 });
    }

    async componentDidMount() {
        await this.checkProductAvailabilityBahag();
    }

    async componentDidUpdate(prevProps) {
        if (this.props.cartOrderRows !== prevProps.cartOrderRows) {
            await this.checkProductAvailabilityBahag();
        }
    }

    async checkProductAvailabilityBahag() {
        const orderRows = this.props.cartOrderRows;
        let availableProducts = 0;
        let unavailableProducts = 0;
        const productsData = [];

        for (let i = 0; i < orderRows.length; i++) {
            const orderRow = orderRows[i];
            const orderRowQuantity = orderRow.quantity;
            const itemEAN = orderRow.itemEAN;

            // Check if product stock is already in the map
            let productStock = this.productStockMap.get(itemEAN);

            // If not, fetch the product stock and update the map
            if (!productStock) {
                productStock = await this.props.getProductStockByEan(itemEAN);
                this.productStockMap.set(itemEAN, productStock);
            }

            let available;

            if (productStock === undefined || productStock === "") {
                available = false;
                unavailableProducts++;
            } else if (productStock.amount === 0 || orderRowQuantity > productStock.amount) {
                available = false;
                unavailableProducts++;
            } else {
                available = true;
                availableProducts++;
            }

            const productData = {
                rowSystemId: orderRow.rowSystemId,
                quantity: orderRowQuantity,
                itemEAN: itemEAN,
                productStock: productStock,
                available: available,
            };
            productsData.push(productData);
        }

        if (unavailableProducts === 0) {
            this.setState({ totalAvailableProducts: translate("checkout.germany.all.products.available") });
            this.setState({ allProductsAvailable: true });
        } else {
            this.setState({
                totalAvailableProducts: `${availableProducts}/${orderRows.length} ${translate("checkout.germany.products.available")}`
            });
            this.setState({ allProductsAvailable: false });
        }
        this.props.setOrderRowsWithBahagInfo(productsData);
    }

    renderResellerOptions() {

        return this.renderSelectedReseller();
    }

    handleRadioChange(selectedReseller) {
        this.checkIfAllProductsNotAvailable();
        this.setState({ selectedReseller });
        this.setState({ selectedItemId: selectedReseller });
        this.props.setReseller(selectedReseller);
    }

    checkIfAllProductsNotAvailable() {
        const isAnyProductNotAvailable = this.props.orderRowsWithStock.some(item => !item.available);
        const missingeProductErrorMessage = document.getElementById("missing-products-cart");
        if (missingeProductErrorMessage) {
            if (isAnyProductNotAvailable) {
                missingeProductErrorMessage.removeAttribute("hidden");
            } else {
                missingeProductErrorMessage.setAttribute("hidden", true);
            }
        }
    }

    renderSelectedReseller() {
        const numberOfItemsToShow = 3;
        const itemsToShowAsTicket = mockData.slice(0, numberOfItemsToShow);
        const itemsToShowAsRow = mockData.slice(numberOfItemsToShow);
        const isAnyProductNotAvailable = this.props.orderRowsWithStock.some(item => !item.available);
        const { isMobileOrTablet } = this.state;

        return (
            <div className='germany-section__container'>
                <>
                    <div className="germany-reseller__apply-reseller">
                        <h1 className="germany-reseller__apply-reseller__section-title">{translate('checkout.germany.reseller.section.description')}</h1>
                    </div>
                    <span className="applay-reseller-button-checkout-container--span"></span>
                </>


                <div className="germany-reseller">
                    {itemsToShowAsTicket.map(item => (
                        <label onClick={() => this.scrollToNextSection(isMobileOrTablet)} key={item.id} className={`germany-reseller--ticket ${this.state.selectedItemId === item.id ? 'germany-reseller--border border' : ''}`}>
                            <div className="germany-reseller__image-container">
                                <img src={item.imageUrl} alt={item.button} />
                            </div>

                            <div className="germany-reseller__title-description--container">
                                <p className="germany-reseller__title-description--title">{item.name}</p>
                            </div>
                            <div className="germany-reseller__title-description">
                                <p className="germany-reseller__title-description--availability">
                                    <span className={`${this.state.allProductsAvailable ? 'germany-reseller__title-description--availability--grean-circle' : 'germany-reseller__title-description--availability--orange-circle '}`}></span>
                                    {this.state.totalAvailableProducts}
                                </p>
                            </div>

                            <div className="germany-reseller__radio-button">
                                <input
                                    type="radio"
                                    id={item.id}
                                    name="resellerRadio"
                                    onChange={() => this.handleRadioChange(item.id)}
                                    checked={this.state.selectedItemId === item.id}
                                />
                                <label htmlFor={item.id}>
                                    {item.button}
                                </label>
                            </div>
                        </label>
                    ))}
                </div>

                {itemsToShowAsRow.length > 0 && (
                    <div className="germany-reseller__full-row">
                        {itemsToShowAsRow.map(listItem => (
                            <label className="germany-reseller__full-row--label">
                                <div key={listItem.id} className="germany-reseller__full-row--item">
                                    <div className="germany-reseller__full-row--item__name-image">
                                        <span></span>
                                        <div className="germany-reseller__full-row--item__name-image--container">
                                            <p className="germany-reseller__full-row--item__name-image--container--name">{listItem.name}</p>

                                            <p className="germany-reseller__title-description--availability">
                                                <span className={`${this.state.allProductsAvailable ? 'germany-reseller__title-description--availability--grean-circle' : 'germany-reseller__title-description--availability--orange-circle '}`}></span>
                                                {this.state.totalAvailableProducts}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="germany-reseller__radio-button-row germany-reseller__full-row--button">
                                        <input
                                            type="radio"
                                            id={listItem.id}
                                            name="resellerRadio"
                                            checked={this.state.selectedReseller === listItem.id}
                                            onChange={() => this.handleRadioChange(listItem.id)}
                                        />
                                        <label htmlFor={listItem.id}>
                                            {listItem.button}
                                        </label>
                                    </div>
                                </div>
                            </label>

                        ))}
                    </div>
                )}
                <div id="missing-products-cart" className="orderRows-not-available--error-message" hidden>
                    <p>{translate("checkout.germany.missing.products.error.message")}</p>
                </div>
                <div className='germany-checkout-cartArrow'></div>
            </div>
        );
    }

    goToSignSection() {
        setTimeout(() => {
            const bahagSignin = document.getElementById("bahag-signin");
            if (bahagSignin) {
                bahagSignin.scrollIntoView({ behavior: 'smooth' });
                this.props.activeSignInSection(true);
            }
        }, 100);
    }

    goToShoppingCart() {
        setTimeout(() => {
            const bahagCart = document.getElementById("bahag-cart");
            if (bahagCart) {
                const headerOffset = 60; 
                const elementPosition = bahagCart.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }, 100);
    }

    scrollToNextSection(isMobileOrTablet) {
        if (isMobileOrTablet) {
            this.goToShoppingCart()
        } else {
            this.goToSignSection()
        }
    }

    render() {
        return (
            <div>
                {this.renderResellerOptions()}
            </div>
        );
    }
}

const mapDispatchToProps = {
    getProductIdByEan,
    getProductStockByEan,
    createAndOrAddToCart,
    createAndAddToCart,
    updateCartEntry,
    updateCartDeliveryAddress,
    removeEntryFromCart,
    createOrder,
    cancelOrder,
    submitOrder,
    createCustomer,
    login,
    logout,
    forgotPassword,
    addAddress,
    getPaymentMode,
    getPaymentModeByCartId,
    load,
    receive,
    activeSignInSection,
    setOrderRowsWithBahagInfo,
    setReseller
};

const mapStateToProps = state => {
    return {
        cartOrderRows: state.cart.orderRows,
        orderRowsWithStock: state.bahag.orderRowsWithStock
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GermanyChooseReseller);
